import React, { useEffect } from 'react';
import history from '~/services/history';
import { useSelector } from 'react-redux';
import { ArquivosExternosProvider } from './ArquivosExternosContext';
import { NotificacaoProvider } from './NotificacaoContext';
import { TransactionsProvider } from './TransactionsContext';
import { RecebimentosProvider } from './RecebimentosContext';
import { ExtratoProvider } from './ExtratoContext';
import { PedidoProvider } from './PedidoContext';
import { FilialProvider } from './FilialContext';
import { ConciliacaoProvider } from './ConciliacaoContext';
import { PlanosProvider } from './PlanosContext';
import { PGMProvider } from './PGMContext';
import { TokenProvider } from './TokenContext';


function AppProvider({ children }) {
	const { user } = useSelector((state) => state.auth);

	useEffect(() => {
		if (user.dados == null) {
			history.push('/auth/login');
		}
	}, [user]);

	if (!user.dados) {
		return null;
	}

	return (
		<TokenProvider user={user}>
			<ArquivosExternosProvider user={user}>
				<NotificacaoProvider user={user}>
					<FilialProvider user={user}>
						<PedidoProvider user={user}>
							<TransactionsProvider user={user}>
								<ExtratoProvider user={user}>
									<RecebimentosProvider user={user}>
										<ConciliacaoProvider user={user}>
											<PlanosProvider user={user}>
												<PGMProvider user={user}>
													{children}
												</PGMProvider>
											</PlanosProvider>
										</ConciliacaoProvider>
									</RecebimentosProvider>
								</ExtratoProvider>
							</TransactionsProvider>
						</PedidoProvider>
					</FilialProvider>
				</NotificacaoProvider>
			</ArquivosExternosProvider>
		</TokenProvider>
	);

}

export default AppProvider;
